import { apiKeyGeoapify as KEY } from 'Utilities/config'

export const generateCoordinates = async (outdoorNumber, street, city, postCode) => {
    const URL = "https://api.geoapify.com/v1"
    const service = "geocode"
    if (outdoorNumber !== "" && street !== "" && city !== "" && postCode !== "") {
        const API = `${URL}/${service}/search?housenumber=${outdoorNumber}&street=${street}&postcode=${postCode}&city=${city}&country=Mexico&apiKey=${KEY}`;
        try {
            const response = await fetch(API);
            const JSON = await response.json()
            const coord = JSON.features[0].geometry.coordinates
            return coord;
        } catch (err) {
            console.log(err)
        }
    }
}

export const generateMapImageURL = ([lon, lat]) => {
    const URL = "https://maps.geoapify.com/v1";
    const service = "staticmap"
    if (lon !== undefined && lat !== undefined) {
        return `${URL}/${service}?style=klokantech-basic&pitch=30&width=800&height=600&center=lonlat:${lon},${lat}&zoom=15&marker=lonlat:${lon},${lat};type:material;color:%23e8584c;size:x-large;icon:store;whitecircle:no&apiKey=${KEY}`;
    } else {
        console.log("Ocurrió un error al agregar la dirección")
        return
    }

}